import Vue from 'vue'
import abpHttp from '../http/AbpHttp';
import l from '../utils/abp.localization';
import isGranted from '../utils/abp.permission';
import { notify, message } from '../utils/abp.vue.implemented';
import { AppConsts } from '../AppConsts';

//常量
Vue.prototype.app = AppConsts; 
//多语言
Vue.prototype.l = l;
//权限
Vue.prototype.isGranted = isGranted;
//http请求
Vue.prototype.http = abpHttp;



//实现abp接口 
/* NOTIFICATION *********************************************/
abp.notify = notify;
/* MESSAGE **************************************************/
abp.message = message;


// WEBPACK FOOTER //
// ./src/shared/libs/ClientFramework/packages/abpVue/common/abp.vue.config.js